import { ArrowDown, cn } from 'design-system'
import { FC, PropsWithChildren, useState } from 'react'
import { ExpandVertical } from 'src/containers/animations/ExpandVertical'

interface ExpandableSectionProps extends PropsWithChildren {
  message: string
  defaultOpen?: boolean
  bgColor?: string
}

export const ExpandableSection: FC<ExpandableSectionProps> = ({
  message,
  defaultOpen = false,
  children,
  bgColor = 'bg-slate-100'
}) => {
  const [open, setOpen] = useState<boolean>(defaultOpen)
  const onToggle = () => {
    setOpen(o => !o)
  }
  return (
    <div
      className={cn('rounded-md px-4 py-2 font-light text-slate-700', bgColor)}>
      <button
        className={cn('flex w-full items-start justify-between gap-x-2', {
          'mb-2': open
        })}
        aria-expanded={open}
        onClick={onToggle}>
        <p className="grow text-left text-sm font-medium">{message}</p>
        <ArrowDown
          size={20}
          aria-hidden
          className={cn('shrink-0 text-blue-500 transition-transform', {
            '-rotate-180': open
          })}
        />
      </button>
      {/* @ts-expect-error expandVertical requires a classname prop */}
      <ExpandVertical scrollOnExpand expanded={open} className="text-sm">
        {children}
      </ExpandVertical>
    </div>
  )
}
